<template>
  <div>
    <!--Banner 区域 -->
    <img
      src="../../assets/img/soBanner.webp"
      alt="product-bg"
      class="w-full h-auto md:h-full object-cover"
    />
    <div class="w-full h-auto md:h-[333px] -mt-8 sm:-mt-12 md:-mt-[60px] gradient-black-bg pb-8 sm:pb-12 md:pb-0">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6 md:gap-8 mx-auto container px-4 sm:px-6 md:px-8">
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));"
        >
          <div class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">10+</div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">项核心知识产权</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">自主研发多套核心系统</div>
          </div>
        </div>
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));"
        >
          <div class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">15+</div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">LBE-VR大空间业态</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">落地城市门店超15家</div>
          </div>
        </div>
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));"
        >
          <div class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">10<span class="text-lg sm:text-2xl">年</span></div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">核心团队技术骨干</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">深耕空间文娱领域超10年</div>
          </div>
        </div>
      </div>
      <div class="text-white text-lg sm:text-xl md:text-2xl lg:text-[36px] font-bold text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[125px] scroll-fade-in mt-6 sm:mt-8 md:mt-12 lg:mt-[60px] px-4">
        马上联系，洽谈合作，把握商机，共创未来
      </div>
    </div>
    <!-- 解决方案 -->
    <SolutionSection variant="blue" />
    <!-- 方案内容 -->
    <div class="blinds-reveal scroll-fade-in">
      <img
        src="../../assets/img/planbg.webp"
        alt="solution-content"
        class="w-full h-auto md:h-full object-cover"
      />
    </div>
    <!-- 合作优势 -->
    <div class="dots-reveal scroll-fade-in">
      <img
        src="../../assets/img/cooperationbg.webp"
        alt="cooperation-advantage"
        class="w-full h-auto md:h-full object-cover"
      />
    </div>
    <!-- 合作模式 -->
    <div
      class="w-full min-h-screen bg-cover bg-center scroll-fade-in relative pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[105px]"
      :style="{ backgroundImage: `url(${cooperationbg})` }"
    >
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <!-- 上部分：标题和主要内容区域（约70%） -->
        <div class="flex flex-col items-center justify-center ">
          <!-- 标题区域 -->
          <div class="flex flex-col items-center scroll-fade-in">
            <!-- 图标和标题 -->
            <img
              src="../../assets/img/coop-icon.webp"
              alt="scene"
              class="mb-4 sm:mb-6 md:mb-8 lg:mb-[24px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-none scroll-fade-in"
            />

            <!-- 副标题文字 -->
            <p class="text-white text-sm sm:text-base md:text-[16px] font-normal text-center mb-6 sm:mb-8 md:mb-10 lg:mb-[45px] px-4">
              多元合作适配需求，低门槛共拓 VR 赛道
            </p>
          </div>

          <!-- 主标题 -->
          <h3 class="text-white text-lg sm:text-xl md:text-2xl lg:text-4xl font-bold text-center mb-12 sm:mb-16 md:mb-24 lg:mb-[446px] max-w-4xl px-4 scroll-fade-in">
            灵活变通的商业合作模式助力您低成本运营无压力
          </h3>

          <!-- 行动号召文字 -->
          <p class="text-white text-lg sm:text-xl md:text-2xl lg:text-4xl font-bold text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[125px] scroll-fade-in mt-8 sm:mt-12 md:mt-16 lg:mt-[155px] px-4">
            欢迎联系考察洽谈，共拓XR元宇宙未来
          </p>

          <!-- 联系信息 -->
          <div class="flex flex-col items-center mb-8 sm:mb-6 md:mb-8 lg:mb-[44px] scroll-fade-in px-4">
            <div class="text-[#20AAE8] text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold">
              立即联系
            </div>
            <div class="w-[120px] sm:w-[150px] md:w-[180px] lg:w-[204px] h-[3px] sm:h-[4px] md:h-[5px] bg-[#20AAE8] rounded-[4px] mt-2 sm:mt-3 mb-2 sm:mb-[12px]"></div>
            <div
              class="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-[#839FF8] to-[#C09BF8] bg-clip-text text-transparent"
              style="-webkit-text-stroke: 1px rgba(0, 0, 0, 0.8); text-stroke: 1px rgba(0, 0, 0, 0.8);"
            >
              130 5258 5965
            </div>
          </div>
          <!-- 合作意向 -->
          <div>
            <img
              src="../../assets/img/cooo.webp"
              alt="scene"
              class="mb-4 sm:mb-6 md:mb-8 lg:mb-12 w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-none scroll-fade-in fade-in-visible"
            />

          </div>
          <CooperationForm />
        </div>

      </div>
    </div>
    <div
      class="w-full relative min-h-[600px] md:h-[482px]"
      style="background: linear-gradient(to bottom, #6267F4 0%, #4247E6 33%, black 100%);"
    >
      <img
        src="../../assets/img/squarebg.webp"
        alt="Digital Handshake"
        class="object-cover w-full h-full min-h-[600px] md:h-full scroll-fade-in-left"
      >
      <div class="absolute top-0 left-0 w-full h-full min-h-[600px] md:h-full bg-black/50 scroll-fade-in">
        <div class="container mx-auto flex flex-col md:flex-row items-center md:items-end justify-center gap-4 sm:gap-6 md:gap-12 lg:gap-[100px] h-full min-h-[600px] md:h-full py-6 sm:py-8 md:py-0 px-4 sm:px-6 md:px-8">
          <img
            src="../../assets/img/square.webp"
            alt="Digital Handshake"
            class="object-contain h-auto w-full 
            lg:mr-[140px]
            max-w-[150px] sm:max-w-[200px] md:max-w-[300px] md:h-full order-1 md:order-none"
          />
          <div class="h-auto md:h-full flex flex-col items-center md:items-start justify-center w-full max-w-full md:w-[600px] md:my-[20px] order-2 md:order-none">
            <div class="items-start w-full flex flex-col justify-center">
              <div class="flex flex-col justify-center 
             items-center md:items-start w-full">
                <div class="text-white text-lg sm:text-xl md:text-[24px] font-bold text-center md:text-left">快速联系</div>
                <div class="text-white text-sm sm:text-base md:text-[16px] font-bold mt-1 text-center md:text-left">立即加入，抢占先机</div>
              </div>
            </div>
            <div class="flex flex-col gap-2 sm:gap-3 md:gap-5 w-full mt-3 sm:mt-4 md:mt-[10%]">
              <div class="text-white text-xs sm:text-sm md:text-[20px] font-bold text-center md:text-left break-all
              lg:pb-[71px] pb-2 px-2
               md:px-0">
                邮箱：<span class="break-all">newmail110@163.com</span>
              </div>
              <div class="text-white text-xs 
              lg:pb-[69px] pb-2
              sm:text-sm md:text-[20px] font-bold text-center md:text-left break-words px-2 md:px-0">
                招商热线：130 5258 5965
              </div>
              <div class="text-white text-xs sm:text-sm md:text-[20px] font-bold text-center md:text-left break-words px-2 md:px-0">
                总部地址：上海市闵行区万芳路515号A座8层
              </div>
            </div>
          </div>
          <div class="flex flex-row gap-3 sm:gap-4 justify-center md:justify-start mb-4 md:mb-[5%] scroll-fade-in-right order-3 md:order-none">
            <div class="flex flex-col items-center">
              <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">
                <img
                  :src="productCodeImg"
                  alt="产品支持二维码"
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="text-white text-[10px] sm:text-[12px] md:text-[14px]">产品支持</div>
            </div>
            <div class="flex flex-col items-center">
              <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">
                <img
                  :src="coopCodeImg"
                  alt="合作咨询二维码"
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="text-white text-[10px] sm:text-[12px] md:text-[14px]">合作咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import SolutionSection from "@/components/SolutionSection.vue";
import CooperationForm from "@/components/CooperationForm.vue";
import cooperationbg from "@/assets/img/coodebg.webp";
import productCodeImg from "@/assets/img/product-code.webp";
import coopCodeImg from "@/assets/img/coop-code.webp";

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        element.classList.add("fade-in-visible");
        animatedElements.add(element);
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素（与产品页保持一致）
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer) {
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
/* 滚动动画效果 - 小元素从底部飞入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 百叶窗式大图动画容器（横向百叶窗：条纹水平、整体上下滑出） */
.blinds-reveal {
  position: relative;
  overflow: hidden;
}

.blinds-reveal img {
  display: block;
  width: 100%;
  height: auto;
  transform: scale(1.03);
  transition: transform 1.2s ease-out;
}

/* 叠加的“百叶窗”遮罩 */
.blinds-reveal::before {
  content: "";
  position: absolute;
  inset: 0;
  /* 横向百叶窗：竖向分层（条纹水平），整体从下往上滑出 */
  background-image: repeating-linear-gradient(
    to bottom,
    rgba(4, 16, 40, 0.95) 0px,
    rgba(4, 16, 40, 0.95) 24px,
    transparent 24px,
    transparent 40px
  );
  transform: translateY(0);
  transition: transform 1.2s ease-out;
  pointer-events: none;
}

/* 进入视口后，遮罩整体上移出画面，形成横向百叶窗打开效果 */
.blinds-reveal.fade-in-visible::before {
  transform: translateY(-100%);
}

.blinds-reveal.fade-in-visible img {
  transform: scale(1);
}

/* 第二张图稍微延迟一点打开 */
.blinds-reveal--delay::before {
  transition-delay: 0.15s;
}
.blinds-reveal--delay img {
  transition-delay: 0.15s;
}

/* 星星点点渐隐展示效果容器 */
.dots-reveal {
  position: relative;
  overflow: hidden;
}

.dots-reveal img {
  display: block;
  width: 100%;
  height: auto;
  transform: scale(1.03);
  transition: transform 1.4s ease-out;
}

.dots-reveal::before {
  content: "";
  position: absolute;
  inset: 0;
  /* 星星点点：用径向渐变 + 重复平铺制造随机感 */
  background-image: radial-gradient(
      circle at 10% 20%,
      rgba(4, 16, 40, 0.95) 0,
      rgba(4, 16, 40, 0.95) 3px,
      transparent 4px
    ),
    radial-gradient(
      circle at 40% 80%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 4px,
      transparent 5px
    ),
    radial-gradient(
      circle at 80% 30%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 2px,
      transparent 3px
    ),
    radial-gradient(
      circle at 60% 60%,
      rgba(4, 16, 40, 0.95) 0,
      rgba(4, 16, 40, 0.95) 3px,
      transparent 4px
    ),
    radial-gradient(
      circle at 20% 70%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 2px,
      transparent 3px
    );
  background-color: rgba(4, 16, 40, 0.92);
  opacity: 1;
  transition: opacity 1.4s ease-out;
  pointer-events: none;
}

/* 进入视口后，遮罩整体淡出，图片略微缩放回正，形成星点散开的感觉 */
.dots-reveal.fade-in-visible::before {
  opacity: 0;
}

.dots-reveal.fade-in-visible img {
  transform: scale(1);
}

.gradient-black-bg {
  position: relative;
  background: transparent;
}

.gradient-black-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: #151827;
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #151827 18%,
    #151827 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #151827 18%,
    #151827 100%
  );
  pointer-events: none;
}

.gradient-border-card {
  position: relative;
}

.gradient-border-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(135deg, #40fff9, #e068ff);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}
</style>
